import React from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import axios from 'axios';
import { apiRequest } from ".././authConfig";

interface RequestInterceptorProps {
    children: JSX.Element,
}

///Questo componente ci permette di intercettare tutte le chiamate HTTP effettuante con Axios 
///ed aggiungere alle chiamate il Bearer token per autenticarsi sull'API.
///Ci permette di ottimizzare il codice e renderlo meno ripetitivo.
///In questa maniera i componenti react inseriti all'interno del componente RequestInterceptor potranno sfruttare la sua particolare features
export const RequestInterceptor: React.FC<RequestInterceptorProps> = ({ children }: RequestInterceptorProps) => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);

  /* eslint-disable no-param-reassign */
  axios.interceptors.request.use(async (config) => {
    //aggiungo il token se e solo se l'utente è loggato su AAD.
    if (account) {
        //throw Error('No active account! Verify a user has been signed in.');
        const response = await instance.acquireTokenSilent({
        ...apiRequest,
        account,
        });

        const bearer = `Bearer ${response.accessToken}`;
        config.headers!.Authorization = bearer;
    }
    return config;
  });
  /* eslint-enable no-param-reassign */

  return (
    <>
      {children}
    </>
  );
};
